import styled from 'styled-components';

import { mediaConfined, mediaWideNavless } from '@xing-com/layout-tokens';
import { space3XL, space5XL, spaceL } from '@xing-com/tokens';

const ArticlesPageWrapper = styled.div`
  margin: 0 0 ${space3XL};
  padding: 0 ${spaceL};

  @media ${mediaConfined} {
    padding: 0;
  }

  @media ${mediaWideNavless} {
    margin: 0 0 ${space5XL};
  }
`;

export const Styled = { ArticlesPageWrapper };
